import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import { formatViews } from "@/utils/movie";

interface MovieCardProps {
  movie: Movie;
  index?: number;
}

const typeLabel: Record<Movie["type"], string> = {
  movie: "电影",
  tv: "剧集",
  variety: "综艺",
};

export default function MovieCard({ movie, index = 0 }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block animate-fade-up cursor-pointer"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <article className="rounded-lg overflow-hidden bg-background-100 border border-background-300/60 transition-all duration-300 group-hover:border-primary-500/60 group-hover:-translate-y-1">
        <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
          <img
            src={movie.cover}
            alt={`${movie.title} 午夜影视封面`}
            title={`${movie.title} - 午夜免费视频`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-transparent opacity-90"></div>
          <div className="absolute top-2.5 left-2.5 flex items-center gap-1.5">
            <span className="px-2 py-0.5 rounded-md bg-primary-500/95 text-background-50 text-[11px] font-label font-semibold">
              {typeLabel[movie.type]}
            </span>
          </div>
          <span className="absolute top-2.5 right-2.5 flex items-center gap-1 px-2 py-0.5 rounded-md bg-background-50/80 backdrop-blur-sm text-foreground-950 text-[11px] font-label font-semibold">
            <i className="ri-star-fill text-primary-400 text-xs"></i>
            {movie.rating.toFixed(1)}
          </span>
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <span className="w-12 h-12 rounded-full bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-play-fill text-2xl pl-0.5"></i>
            </span>
          </div>
          <div className="absolute bottom-2.5 left-2.5 right-2.5 flex items-center gap-2 text-[11px] text-foreground-700 font-label">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line text-xs"></i>
              {formatViews(movie.views)}
            </span>
            <span className="text-foreground-500">·</span>
            <span>{movie.region}</span>
          </div>
        </div>
        <div className="p-3">
          <h3 className="text-sm font-medium text-foreground-950 truncate group-hover:text-primary-400 transition-colors">
            {movie.title}
          </h3>
          <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-600">
            <span>{movie.year}</span>
            <span className="text-foreground-500">·</span>
            <span className="truncate">{movie.genres.join(" / ")}</span>
          </div>
        </div>
      </article>
    </Link>
  );
}